import { string, object } from 'yup';
import { TENANT_CONTACT, CARRIER_CONTACT, DELIVERY_NOTE } from '../constants';
import { messages } from './messages';

const contactSchema = object({
  name: string().required(messages.requiredError),
  phone: string().required(messages.requiredError),
  email: string().email(messages.invalidEmail).required(messages.requiredError),
});

export const FreightConfigurationSchema = object({
  [TENANT_CONTACT]: contactSchema,
  [CARRIER_CONTACT]: contactSchema,
  [DELIVERY_NOTE]: string().optional().nullable(),
  dropOffDateOptionOne: string().required(messages.requiredError),
  dropOffDateOptionTwo: string().required(messages.requiredError),
  dropOffDateOptionThree: string().required(messages.requiredError),
  timePickerOne: string().required(messages.requiredError),
  timePickerTwo: string().required(messages.requiredError),
  timePickerThree: string().required(messages.requiredError),
});
